import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

import { addClassName } from './index.utils';

import './index.scss';

/**
 * text field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const TextAreaCommon = props => {
  const {
    field: { name, value },
    placeholder,
    existError,
    showError,
    rows,
    maxlength,
    disabled,
    eventEmitter,
    ...other
  } = props;
  const [valueLocal, setValueLocal] = useState(value);

  // TODO observable value
  useEffect(() => {
    setValueLocal(value);
  }, [value]);

  // on change value
  const onChange = event => setValueLocal(get(event, 'target.value'));

  // on blur value
  const onBlur = () => eventEmitter(valueLocal);

  return (
    <textarea
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      className={addClassName({ existError, showError })}
      placeholder={placeholder}
      name={name}
      rows={rows}
      disabled={disabled}
      maxLength={maxlength}
      value={valueLocal}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};

TextAreaCommon.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  placeholder: PropTypes.string,
  existError: PropTypes.bool,
  showError: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  maxlength: PropTypes.number,
  eventEmitter: PropTypes.func.isRequired,
};

TextAreaCommon.defaultProps = {
  field: {
    value: undefined,
  },
  placeholder: '',
  rows: 3,
  maxlength: undefined,
  disabled: false,
  existError: false,
  showError: false,
};

export default TextAreaCommon;
